import axios, { Method } from '@/apps/open/utils/axios'

const resourceName = '/api/service/wwo'

/**
 * weboffice应用列表
 */
export function getWebofficeList (params: any) {
  return axios({ url: `${resourceName}/developer/apps`, method: Method.Get, params })
}

/**
 * 获取weboffice应用详情
 * @param id
 */
export function getWebofficeById (id: string, params: any) {
  return axios({ url: `${resourceName}/apps/${id}`, method: Method.Get, params })
}

/**
 * 添加weboffice应用
 * @param data
 */
export function applyWeboffice (data: object, params: object) {
  return axios({ url: `${resourceName}/apps`, method: Method.Post, data, params })
}

/**
 * 重置APP KEY
 * @param id
 */
export function resetWebofficeKey (id: string, params: any) {
  return axios({ url: `${resourceName}/apps/${id}/appkey`, method: Method.Put, params })
}

/**
 * 重新填写应用信息
 * @param id
 * @param data
 */
export function updateWebofficeInfo (id: string, data: object, params: object) {
  return axios({ url: `${resourceName}/apps/${id}`, method: Method.Put, data, params })
}

/**
 * 更新回调地址
 * @param id
 * @param data
 */
export function updateWebofficeCallback (id: string, data: object, params: object) {
  return axios({ url: `${resourceName}/apps/${id}/webconfig/callback_url`, method: Method.Put, data, params })
}

/**
 * 数据统计
 * @param appid
 * @param type
 * @param from
 * @param to
 */
export function statistics (appid: string, type: string, from: string, to: string, developer_id: number) {
  let params = {
    type: type,
    from: from,
    to: to,
    developer_id
  }
  return axios({ url: `/api/service/wwo/statistics/${appid}`, method: Method.Get, params })
}
